export const steps = {
  one: 0,
  two: 1,
  three: 2,
  four: 3,
};
